module.exports = __webpack_public_path__ + "img/mood01_300px.53040bf0.jpg";